<router-outlet>
    <ngx-ui-loader />
</router-outlet>
